<template>
    <div class="c-modal flex flex-align-center flex-justify-center" :class="{ 'is-open': value }" v-dom-portal>
        <button aria-label="Close map modal" class="c-modal__close" @click="close_modal()">
            <span aria-hidden="true" class="feather icon-x"></span>
        </button>

        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'ModalBase',

        props: [
            'value'
        ],

        methods: {
            close_modal() {
                this.$emit('input', false);
            }
        },

        mounted: function() {
            document.addEventListener('keydown', (e) => {
                if (this.value && e.keyCode == 27) {
                    this.$emit('input', false);
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/imports";

    .c-modal {background: rgba(0, 0, 0, .95); height: 100%; opacity: 0; pointer-events: none; position: fixed; top: 0; left: 0; transition: .3s; width: 100%; z-index: 999;
        &.is-open {opacity: 1; pointer-events: auto;}
        
        &__close {@include appearance; border: 1px solid $grey-border; border-radius: 50%; z-index: 99; color: $white; font-size: 1.25rem; height: 48px; line-height: 46px; position: absolute; text-align: center; top: $gutter*4; right: $gutter*4; transition: .25s; width: 48px;
            &:hover, &:focus {background: $purple; cursor: pointer;}
        }
    }
</style>